import { Navigate, useLocation, useParams } from "react-router";

import InvalidRoute from "@/app/pages/InvalidRoute";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { EnvironmentUrl } from "@reflag/shared/urls";

export default function GoToDefaultEnv() {
  const { env } = useEnvironment();
  const { search, hash } = useLocation();

  const { "*": splat } = useParams();
  if (!env) return <InvalidRoute />;
  const newPath = splat
    ? `${EnvironmentUrl(env)}/${splat}`
    : EnvironmentUrl(env);

  return <Navigate to={`${newPath}${search}${hash}`} replace />;
}
